import { create } from "zustand";
import { persist } from "zustand/middleware";

interface UserData {
  nickname: string;
  access_level: number;
}

interface AuthState {
  isAuthenticated: boolean;
  accessToken: string | null;
  refreshToken: string | null;
  userData: UserData | null;
}

interface AuthAction {
  login: (
    token: { accessToken: string; refreshToken: string },
    userData: UserData
  ) => void;
  logout: () => void;
}

const initialState: AuthState = {
  isAuthenticated: false,
  accessToken: null,
  refreshToken: null,
  userData: null,
};

export const useAuthStore = create<AuthState & AuthAction>()(
  persist(
    (set, get) => ({
      ...initialState,
      login: (token, userData) => {
        set({
          isAuthenticated: true,
          accessToken: token.accessToken,
          refreshToken: token.refreshToken,
          userData: userData,
        });
      },
      logout: () => {
        set(initialState);
      },
    }),
    {
      name: "aivy-admin-storage",
      partialize: (state) => ({
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        userData: state.userData,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);

export const useIsAuthenticated = () =>
  useAuthStore((state) => state.isAuthenticated);
export const useUserData = () => useAuthStore((state) => state.userData);
export const useAccessToken = () => useAuthStore((state) => state.accessToken);
export const useLogout = () => useAuthStore((state) => state.logout);
